module.exports = "pegasus_template/assets/gray-ghost-twitter.png";